import { animate, query, stagger, style, transition, trigger } from '@angular/animations';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { BaseComponent } from '@ex/module/core/domain/base-component';
import { TourStep } from '@ex/module/shared/product-tour/models/tour-step';
import { debounceTime } from 'rxjs/operators';

export const listAnimation = trigger('listAnimation', [
  transition(':enter', [
    query(
      ':enter',
      [
        style({ opacity: 0, transform: 'translateY(40px) rotateX(90deg)' }),
        stagger(
          '50ms',
          animate(
            '600ms cubic-bezier(0,.81,.18,1)',
            style({ opacity: 1, transform: 'translateY(0px) rotateX(0deg)' })
          )
        ),
      ],
      { optional: true }
    ),
  ]),
]);

export interface SurveySidebarRoute {
  route: string;
  label?: string;
  icon?: string;
  tourStep?: TourStep
}

export interface SurveySidebarSection {
  label?: string;
  routes: SurveySidebarRoute[];
}

@Component({
  selector: 'survey-sidebar',
  templateUrl: './survey-sidebar.component.html',
  styleUrls: ['./survey-sidebar.component.scss'],
  animations: [listAnimation]
})
export class SurveySidebarComponent extends BaseComponent implements OnInit {
  @Output() collapsedChange = new EventEmitter<boolean>();
  @Input() language = 'EN';
  @Input() sectionRoutes: SurveySidebarSection[] = [];
  @Input() collapsable = true;
  private _collapsed = false;
  @Input()
  set collapsed(value: boolean) {
    this._collapsed = !!value;
  }
  get collapsed(): boolean {
    return this._collapsed;
  }


  constructor(private router: Router) {
    super();
  }

  ngOnInit(): void {

  }

  setCollapsed(value: boolean) {
    if (this._collapsed === value) return;
    this._collapsed = value;
    this.collapsedChange.emit(this._collapsed);

    // Notify the browser of a resize so components (e.g., charts) can adjust
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 300); // Delay to allow CSS transition to complete
  }

  toggleCollapsed() {
    this.setCollapsed(!this._collapsed);
  }
}
